import { Avatar, HStack, Tooltip, Box } from "@chakra-ui/react";
import React from "react";

interface WebSocketUserDto {
  userId: string;
  userName: string;
  userColor: string;
  isConnected?: boolean;
}

interface UserPresenceIndicatorProps {
  connectedUsers: WebSocketUserDto[];
  currentUserId: string;
}

export function UserPresenceIndicator({
  connectedUsers,
  currentUserId,
}: UserPresenceIndicatorProps) {
  const otherUsers = connectedUsers.filter((u) => u.userId !== currentUserId);

  if (otherUsers.length === 0) {
    return null;
  }

  return (
    <HStack spacing={2}>
      <Box
        bgColor="red"
        color="white"
        px={2}
        py={1}
        borderRadius="full"
        fontSize="xs"
        fontWeight="medium"
      >
        {otherUsers.length} other user{otherUsers.length > 1 ? "s" : ""}
      </Box>
      {otherUsers.map((user) => (
        <Tooltip key={user.userId} label={user.userName}>
          <Avatar
            size="xs"
            name={user.userName}
            bg={user.userColor}
            color="white"
            border="1px solid white"
            boxShadow="sm"
          />
        </Tooltip>
      ))}
    </HStack>
  );
}
